/**
 * FlashEffect
 *
 * 解析結果が新しく到着した時に、画面全体を一瞬グリーンにフラッシュさせる演出。
 *
 * 親側で `key={result.id}` を指定して使う想定。
 * key が変わると要素が再マウントされ、CSSアニメーションがゼロから再生される。
 */

import styles from './FlashEffect.module.css';

export function FlashEffect() {
  return <div className={styles.flash} aria-hidden />;
}
